define('lib/Podio.UI.Space.ShareSpaceModal',['require','translate','underscore','jquery','lib/jquery/jquery.customcheckbox','jquery.cookie','lib/Podio.Transport.Space','lib/Podio.Transport.Apps','lib/Podio.UI.Modal','lib/Podio.Event.UI','lib/Podio.Config'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  require('lib/jquery/jquery.customcheckbox');
  require('jquery.cookie');

  var transportSpace = require('lib/Podio.Transport.Space');
  var transportApps = require('lib/Podio.Transport.Apps');
  var modal = require('lib/Podio.UI.Modal');
  var eventUI = require('lib/Podio.Event.UI');
  var podioConfig = require('lib/Podio.Config');

  var elmModalContent, currentSpaceId, currentOrgId, shareFormUrl;
  var modalWidth = 578, modalTitle;
  var selectedFeatures = [], selectedAppIds = [];
  var appsDependencies, appsList, textReferences;

  var baseUrl;

  function compare_app_id(app_id, i) {
    return i['app_id'] == app_id;
  }

  function goToShareForm() {
    modal.showLoading(modalTitle, { width: modalWidth });

    var queryString = '?features=' + selectedFeatures.join(',') + '&apps=' + selectedAppIds.join(',');
    if(currentOrgId) {
      queryString += '&org_id=' + currentOrgId;
    }

    location.href = shareFormUrl + queryString;
  }

  function onViewFeaturesModal(responseData) {
    if (!responseData.has_features) {
      goToShareForm();
    } else {
      onShowViewModal(responseData);
      $("div.share-space-modal input[type=checkbox]").customCheckbox();
    }
  }

  function onViewAppsModal(responseData) {

    appsList = responseData.apps;
    appsDependencies = responseData.dependencies;
    textReferences = responseData.textReferences;

    onShowViewModal(responseData);
  }

  function onShowViewModal(responseData) {
    if (responseData.title) {
      modalTitle = responseData.title;
    }
    if (responseData.share_form_url) {
      shareFormUrl = responseData.share_form_url;
    }
    modal.show(responseData.body, { width: modalWidth, title: modalTitle, footerHtml : responseData.footer, className: 'share-space-modal', hideHandler: onModalHide });
    elmModalContent = $('div.appstore-modal-tryapp');
  }

  function onModalHide() {
    currentSpaceId = undefined;
    modalTitle = undefined;
    selectedFeatures = [];
    selectedAppIds = [];
    appsDependencies = {};
    appsList = {};

    return true;
  }

  function onNewSpaceTemplateClicked(elmTarget, e) {
    currentOrgId = elmTarget.data('org-id');
    onNewAppPackClicked();
  }

  function onNewAppPackClicked(elmTarget, e) {
    modal.showLoading(modalTitle, { width: modalWidth });
    transportSpace.getShareSpaceAppsModalLayout(currentSpaceId, onViewAppsModal, baseUrl);
  }

  function addDependencyWarning(app1, app2) {
    var appItem = $('div.share-space-modal .app-list > li[data-id=' + app1.app_id  + '].selected');
    if(appItem.length) {
      if($('div.share-space-modal .app-dependency-warning li[data-id=' + app1.app_id + ']').length === 0) {
        $('div.share-space-modal .app-dependency-warning ul').append('<li data-id="' + app1.app_id + '"> - <strong>' + app1.name + '</strong> ' + textReferences + ' <strong>' + app2.name + '</strong></li>' );
      }
      appItem.addClass('warning');
    }
  }
  function removeDependencyWarning(app1) {
    $('div.share-space-modal .app-dependency-warning li[data-id=' + app1.app_id + ']').remove();
    $('div.share-space-modal .app-list > li[data-id=' + app1.app_id + ']').removeClass('warning');
  }

  function resolveMasterAppDependencies(masterappId) {
    var appMasterDependencies = [];
    for (var key in appsDependencies) {
       if (appsDependencies.hasOwnProperty(key)) {
         var item = appsDependencies[key];
         if(item.indexOf(masterappId) != -1) {
           appMasterDependencies.push(key);
         }
       }
    }

    return appMasterDependencies;
  }

  function onAppItemClicked(elmTarget, e) {
    e.preventDefault();
    if(elmTarget.siblings('.selected').length < 1) {
      return; // Do not allow user to uncheck all apps
    }

    elmTarget.toggleClass('selected');
    var isSelected = elmTarget.is('.selected');

    var elmAppDependencyWarning = $('div.share-space-modal .app-dependency-warning');
    var clickAppObject = _.detect(appsList, function(o) { return o['app_id'] == elmTarget.data('id'); });
    var appMasterDependencies = resolveMasterAppDependencies(clickAppObject.app_id);
    var appChildDependencies = appsDependencies[clickAppObject.app_id];

    if(appChildDependencies) {
      $('div.share-space-modal .app-list > li:not(.selected)').each(function() {
        var itemAppId = $(this).data('id');
        if(appChildDependencies.indexOf(itemAppId) === -1) {
          return;
        }

        var dependencies = resolveMasterAppDependencies(itemAppId);
        var appObject2 = _.detect(appsList, compare_app_id.curry(itemAppId));
        for (var i = 0, len = dependencies.length; i < len; i++) {
          var appId = dependencies[i];
          var appItemObject = _.detect(appsList, compare_app_id.curry(appId));
           if(isSelected && appItemObject) {
            addDependencyWarning(appItemObject, appObject2);
           } else {
            removeDependencyWarning(clickAppObject);
           }
        }
      });
    }

    if(appMasterDependencies) {
      for (var i = 0, len = appMasterDependencies.length; i < len; i++) {
        var itemAppId = appMasterDependencies[i];
        var itemAppObject = _.detect(appsList, compare_app_id.curry(itemAppId));
        if(isSelected) {
           removeDependencyWarning(itemAppObject);
        } else {
          addDependencyWarning(itemAppObject, clickAppObject);
        }
      }
    }

    if($('div.share-space-modal .app-dependency-warning li').length > 0) {
      elmAppDependencyWarning.show();
    } else {
      elmAppDependencyWarning.hide();
    }
  }

  function onSelectAppsClicked(elmTarget, e) {
    e.preventDefault();

    $('div.share-space-modal .app-list li.selected').each(function() {
      selectedAppIds.push($(this).data('id'));
    });

    modal.showLoading(modalTitle, { width: modalWidth });
    transportSpace.getShareSpaceFeaturesModalLayout(currentSpaceId, selectedAppIds.join(','), onViewFeaturesModal, baseUrl);
  }

  function onFeatureItemClicked(elmTarget, e) {
    var elmInput = elmTarget.find('input[type=checkbox]');
    if (elmInput.is(':checked')) {
      elmInput.prop('checked', false);
    } else {
      elmInput.prop('checked', true);
    }
    elmInput.trigger('updateState');
  }

  function onNextFeaturesClicked(elmTarget, e) {
    e.preventDefault();

    $('div.share-space-modal .features-list li input:checked').each(function() {
      var elmItem = $(this).parents('li');
      var key = elmItem.data('name');
      selectedFeatures.push(key);
    });

    goToShareForm();
  }

  function onAddAppLinkClicked(elmTarget, e) {
    var baseDomain = podioConfig.base_domain;
    $.cookie("last-space-id", elmTarget.data('space-id'), { path: '/', domain: baseDomain});

    modal.showLoading(t('Add app #spacenavigation'));
    transportApps.getAddAppModalLayout(function(responseData) {
      modal.show(responseData.data.html, {title: t('Add app #spacenavigation'), className:'add-app-modal'});
    });
  }

  function show(spaceId, transportBaseUrl) {
    currentSpaceId = spaceId !== undefined ? spaceId : currentSpaceId;

    baseUrl = transportBaseUrl;

    modal.showLoading(modalTitle, { width: modalWidth });
    transportSpace.getShareSpaceModalLayout(currentSpaceId, onShowViewModal, baseUrl);
  }

  // Init
  eventUI.bind('click', 'div.share-space-modal .new-app-pack', onNewAppPackClicked);
  eventUI.bind('click', 'div.share-space-modal .share-org-app-store', onNewSpaceTemplateClicked);
  eventUI.bind('click', 'div.share-space-modal .select-apps', onSelectAppsClicked);
  eventUI.bind('click', 'div.share-space-modal .features-next', onNextFeaturesClicked);
  eventUI.bind('click', 'div.share-space-modal .app-list > li', onAppItemClicked);
  eventUI.bind('click', 'div.share-space-modal .features-list > li', onFeatureItemClicked);
  eventUI.bind('click', 'div.share-space-modal .add-app', onAddAppLinkClicked);

  return {
    show: show
  };

});


